import { render, staticRenderFns } from "./LocationManagement.vue?vue&type=template&id=d3223d84"
import script from "./LocationManagement.vue?vue&type=script&lang=js"
export * from "./LocationManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports